import { render, staticRenderFns } from "./PersonalDataTeamRequired.vue?vue&type=template&id=2988e3ee&scoped=true"
import script from "./PersonalDataTeamRequired.vue?vue&type=script&lang=js"
export * from "./PersonalDataTeamRequired.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataTeamRequired.vue?vue&type=style&index=0&id=2988e3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988e3ee",
  null
  
)

export default component.exports